import SuccessFooterBanner from './SuccessFooterBanner';

export default SuccessFooterBanner;
